import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


export function passwordStrengthValidator(): ValidatorFn{

    const specialRegex = /[#$%&?@$. _-]/;

    return (control: AbstractControl): ValidationErrors | null => {

        const value: string = control.value || '';

        if(!value){
            // Deja que "required" se encargue si está vacío
            return null;
        }

        const errors:any = {};

        if(value.length < 6){
            errors.minLength = true;
        }

        if(!/[A-Z]/.test(value)){
            errors.uppercase = true;
        }

        if(!/[a-z]/.test(value)){
            errors.lowercase = true;
        }

        if(!/[0-9]/.test(value)){
            errors.number =  true;
        }

        if(!specialRegex.test(value)){
            errors.special = true;
        }

        return Object.keys(errors).length ? errors : null;
    }
}